import { Form, Input, Button } from "antd";
import React, { useState } from "react";
import styles from './SaveFilter.module.scss';

const FILTER_NAME_FIELD = 'name'

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

const SaveFilterContent = ({
  onSubmit,
  onCancel,
  initialValue = '',
  maxLength = 25,
  form
}) => {

  const { getFieldValue, getFieldDecorator, validateFields, getFieldsError, resetFields } = form;

  const [isPending, setIsPending] = useState(false);

  const filterName = getFieldValue(FILTER_NAME_FIELD) || '';

  const isDisabled = hasErrors(getFieldsError()) || isPending || filterName.length === 0;

  const wrappedOnSubmit = (e) => {
    e.preventDefault();

    validateFields(async (err, values) => {
      if (err) {
        return;
      }

      setIsPending(true);

      try {
        await onSubmit({ filterName: values[FILTER_NAME_FIELD].trim() });
        resetFields();
      } finally {
        setIsPending(false);
      }
    });
  };

  return (
    <Form onSubmit={wrappedOnSubmit}>
      <Form.Item
        help={filterName.length === maxLength && `Наименование должно быть не более ${maxLength} символов`}
        style={{textAlign: 'left'}}
        extra={`${
          filterName.length
        }/${maxLength}`}
        className={styles.form}
      >
        {getFieldDecorator(FILTER_NAME_FIELD, {
          initialValue: initialValue,
        })(
          <Input
            type="text"
            className={styles.input}
            maxLength={maxLength}
            autoFocus
          />
        )}
      </Form.Item>

      <Button onClick={onCancel} className={styles.cancel}>
        Отмена
      </Button>

      <Button disabled={isDisabled} type="primary" htmlType="submit">
        OK
      </Button>
    </Form>
  );
};

export const SaveFilter = Form.create({ name: 'drawer_filter_save_form' })(SaveFilterContent);
